import { formatInTimeZone } from "date-fns-tz";
import { CinemaHallField } from "types/index";

export function getCinemaHallTimeZone(
  cinemaHalls: CinemaHallField[] | undefined,
  hallName: string | undefined,
) {
  return cinemaHalls?.find((hall) => hall.name === hallName)?.timezone;
}

export function formatShowDateTime(
  isoDateTime: string,
  timezone: string | undefined,
  formatStr: string,
) {
  if (!timezone) return null;
  return formatInTimeZone(new Date(isoDateTime), timezone, formatStr);
}
